import { render, staticRenderFns } from "./onAction.vue?vue&type=template&id=37dd9089&scoped=true"
import script from "./onAction.vue?vue&type=script&lang=js"
export * from "./onAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dd9089",
  null
  
)

export default component.exports